
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type TSettingState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        loading: boolean,
        sortBy: string,
        sortColumn:string,
    }
    
    
    const initialSettingState: TSettingState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 0,
        searchTerm: "",
        loading: false,
        sortBy: "desc",
        sortColumn:""
    
        
    }
    
    export const settingSlice = createSlice({
        name: 'setting',
        initialState:initialSettingState,
        reducers: {
            setSetting: (state:TSettingState, { payload }: PayloadAction<[]>) => {
              state.data=payload
             },
            setPerPage: (state:TSettingState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
            setCurrentPage: (state:TSettingState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:TSettingState, {payload}: PayloadAction<number>) => { },
            setSearchTerm: (state:TSettingState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:TSettingState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:TSettingState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:TSettingState, {payload}: PayloadAction<boolean>) => { 
              state.loading = payload
            },
        },
    })
    
    
    export const { setSetting, setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading } = settingSlice.actions
    export default settingSlice.reducer
    